import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: "*", redirect: "/" },
  { path: "/", redirect: "/show" },
  { path: '/show', name: 'show', component: resolve => require(['@/views/main/PersonnelShow.vue'], resolve), },
  { path: '/login', name: 'login', component: resolve => require(['@/views/Login'], resolve), },
  { 
    path: '/main', name: 'main', component: resolve => require(['@/views/Main'], resolve), 
    children: [
      { path: 'personnellist', name: 'personnellist', component: resolve => require(['@/views/main/PersonnelList.vue'], resolve) },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title != undefined) {
    window.document.title = to.meta.title;
  } else {
    window.document.title = '東京瑪妮';
    // window.document.title = 'PDD TECH';
  }
  next()
})

export default router
